<template>
  <v-container class="vh-footer ps-re lynn-mobile lynn-web-in bg-gray" fluid>
    <div class="web-side"></div>
    <div class="location-box np">
      <div class="web-logo">
        <Weblogo width="55" height="30" />
      </div>
      <a @click="$router.push('/contract')" class="back">
        <Back />
      </a>
      <strong class="lo-title">
        AS 접수 목록
        <!--새로고침 버튼 추가 기능 완료시 풀어주세요.-->
        <!--<span class="lo-reload" @click="inRotate"><v-icon :class="{rotate:inrotate}">mdi-cached</v-icon></span>-->
      </strong>
    </div>
    <v-card max-width="750" class="mx-auto bg-gray nops">
      <v-card-text style="padding-top:0px; margin-top:0px;">
        <v-row>
          <v-col>
            <v-chip-group v-model="status" mandatory>
              <v-chip small value="ALL" outlined :color="colorByStatus('ALL')">
                전 체
              </v-chip>
              <v-chip small value="REQUESTED" outlined :color="colorByStatus('REQUESTED')">
                <v-icon small>mdi-timer-sand-empty</v-icon>
                접수중
              </v-chip>
              <v-chip small value="OPEN" outlined :color="colorByStatus('OPEN')">
                <v-icon small>mdi-account-hard-hat-outline</v-icon>
                AS처리중
              </v-chip>
              <v-chip small value="CLOSE" outlined :color="colorByStatus('CLOSE')">
                <v-icon small>mdi-check</v-icon>
                AS처리완료
              </v-chip>
              <v-chip small value="CANCELLED" outlined :color="colorByStatus('CANCELLED')">
                <v-icon small>mdi-cancel</v-icon>
                AS미대상
              </v-chip>
              <v-spacer></v-spacer>
              <v-btn v-if="!isXs && !hideDefect" text color="primary" @click="moveToAdd()">
                <v-icon>mdi-plus-circle-outline</v-icon>
                신규 AS 접수
              </v-btn>
            </v-chip-group>
          </v-col>
        </v-row>
        <v-card v-for="(item, index) in filteredItems" :key="index" flat ripple class="item-card"
          @click="moveToDetail(item.id)">
          <span class="order-style"> {{ item.order }}</span>
          <v-list>
            <v-list-item :key="item.title">
              <v-list-item-avatar>
                <v-icon color="primary" v-if="item.defectStatus == 'OPEN' && item.visitAt && type != 'PRE'">
                  mdi-account-hard-hat-outline
                </v-icon>
                <v-icon color="success" v-else-if="item.defectStatus == 'REQUESTED'">
                  mdi-timer-sand-empty
                </v-icon>
                <v-icon color="primary" v-else-if="item.defectStatus == 'OPEN'">
                  mdi-timer-sand-empty
                </v-icon>
                <v-icon color="red" v-else-if="item.defectStatus == 'CANCELLED'">
                  mdi-cancel
                </v-icon>
                <v-icon color="grey" v-else>
                  mdi-check
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-html="item.title" style="font-weight:500;"></v-list-item-title>
                <v-list-item-subtitle class="mt-1" v-html="item.createdAtText"></v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.defectStatus == 'OPEN' && item.visitAt && type != 'PRE'"
                  class="font-weight-bold primary--text" v-html="item.visitAtText"></v-list-item-subtitle>
                <v-list-item-subtitle v-else-if="item.defectStatus == 'REQUESTED'"
                  class="font-weight-bold success--text" v-html="'접수중'"></v-list-item-subtitle>
                <v-list-item-subtitle v-else-if="item.defectStatus == 'OPEN'" class="font-weight-bold primary--text"
                  v-html="'AS 처리중'"></v-list-item-subtitle>
                <v-list-item-subtitle v-else-if="item.defectStatus == 'CANCELLED'" class="font-weight-bold red--text"
                  v-html="'AS 미대상'"></v-list-item-subtitle>
                <v-list-item-subtitle v-else-if="item.defectStatus == 'CLOSE'"
                  class="font-weight-bold grey--text text--darken-2">
                  AS 처리완료 <v-btn elevation="0"  x-small color="primary" class="ml-2 pa-1" v-if="defectSurveysMap.get(item.id)" readonly>만족도 조사</v-btn>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-else v-html="item.receiptAtText"></v-list-item-subtitle>
                <!-- <v-list-item-subtitle
                  v-show="item.defectStatus == 'CLOSE'"
                  v-html="item.visitAtText"
                ></v-list-item-subtitle> -->
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
        <li class="no-list mt-5" v-if="isLoading">
          <p>로딩 중 입니다..</p>
        </li>
        <li class="no-list mt-5" v-else-if="!items.length">
          <p>접수된 AS가 없습니다.</p>
        </li>
        <li class="no-list mt-5" v-else-if="!filteredItems.length">
          <p>해당되는 상태의 AS가 없습니다.</p>
        </li>
      </v-card-text>
    </v-card>
    <!-- <v-btn block text @click="loadMore" color="success" v-show="showLoadMore"><v-icon>mdi-plus-circle </v-icon>모든 내역
      조회</v-btn> -->
    <v-btn color="primary" fab dark bottom right fixed class="float-add-button" v-if="isXs && !hideDefect"
      @click="moveToAdd()">
      <v-icon large>mdi-plus</v-icon>
    </v-btn>

    <SurveyDialog v-if="survey.dialog" :survey="survey" @close="survey.dialog = false" />


    <!--신규 팝업 테스트 25.04.30 bong-->
    <v-dialog v-model="newisopenpop" max-width="540">
      <div class="testPopSet">
        <strong class="testPSTitle">사전방문행사 점검사항 조치계획</strong>
        <div class="testPSText">
          <p class="big">{{ this.home.dong_no }}동 {{ this.home.ho_no }}호 사전방문행사 점검사항은 각 유형에 따라 적합한 방법으로 고객님께서 입주하시기 전까지
            조치할
            예정입니다.</p>
          <span class="tspace"></span>
          <p class="color">다음과 같은경우에는 별도로 개별 안내를 드리겠습니다.</p>
          <p class="inc">공사 여건상 자재, 장비 또는 인력등의 수급이 곤란한 경우</p>
          <p class="inc">공정 및 공사의 특성상 사용검사를 받기 전까지 보수공사등을 하기 곤란한 경우</p>
          <p class="inc">그 밖에 천재지변이나 부득이한 사유가 있는 경우</p>
        </div>
      </div>
      <div class="testSetBtn">
        <label>
          <input type="checkbox" v-model="doNotShowToday" />다시 보지 않기
        </label>
        <v-btn color="primary darken-1" @click="closePopup">확인</v-btn>
      </div>
    </v-dialog>
    <!--신규 팝업 테스트 25.04.21 bong-->
  </v-container>
</template>

<script>
import * as defect from "@/api/defect";
import { checkSurvey } from "@/api/survey";
import Weblogo from "@/assets/images/common/new-logo.svg";
import Back from "@/assets/images/icon/icon-back.svg";
import SurveyDialog from "@/components/Survey/SurveyDialog";
import { checkAppVersion } from "../../api";

export default {
  name: "DefectList",
  components: { Back, Weblogo, SurveyDialog },
  data() {
    return {
      newisopenpop: true, // 팝업창 여/부 state
      type: "AFTER",
      show: true,
      cancelDialog: false,
      page: 1,
      status: "ALL",
      isLoading: true,
      items: [],
      isSimple: true,
      showLoadMore: false,
      scrollY: 0,
      inrotate: false,

      doNotShowToday: false,


      survey: {
        dialog: false,
        popup_period: null
      },

      // 하자 등록 설문 조회 결과
      defectSurveys: [],
      defectSurveysMap: new Map(),
    };
  },
  mounted() { // 화면 그려지고 실행하는 함수

    if (this.is_using_popup_village) {
      const savedTime = localStorage.getItem("expireTodayTime");
      // 변수 savedTime에 로컬스토리지에 적용한 key 'expireTodayTime'의 value값 적용
      if (savedTime && new Date().getTime() < parseInt(savedTime)) {
        // savedTime 값이 있고, mounted 될 때 시간이 savedTime 값보다 작으면
        this.newisopenpop = false;	// 팝업 닫기
      }
    } else {
      this.newisopenpop = false;
    }
  },
  computed: {
    hideDefect() {
      const now = new Date();

      let defectAddClosed = false;
      if (this.type == "PRE" && this.home.defect_pre_end_at) {
        defectAddClosed = new Date(this.home.defect_pre_end_at) < now;
      } else if (this.type != "PRE" && this.home.defect_after_end_at) {
        defectAddClosed = new Date(this.home.defect_after_end_at) < now;
      }

      let defectMenuOpen = false;

      if (this.type == "PRE") {
        defectMenuOpen = this.home.is_defect_pre_open;
      } else {
        defectMenuOpen = this.home.is_defect_after_open;
      }

      // 입주자 접수

      return defectAddClosed || !defectMenuOpen;
    },
    isXs() {
      return this.$vuetify.breakpoint.xs;
    },
    filteredItems() {
      if (this.status == "ALL") {
        return this.items;
      }
      return this.items.filter((item) => item.defectStatus == this.status);
    },
    user() {
      return this.$store.getters.getUser;
    },
    home() {
      // if (this.type == "AFTER") {
      //   return this.$store.getters.getTenantHome || this.$store.getters.getHome;
      // } else {
      //   return this.$store.getters.getHome;
      // }

      return this.$store.getters.getHome;
    },
    browserInfo() {
      return navigator.userAgent.toLowerCase();
    },
    userState() {
      return this.$store.getters.getUserState;
    },
    is_android() {
      return this.browserInfo.indexOf("android") > 0;
    },
    is_ios() {
      return this.browserInfo.indexOf("iphone") > 0 || this.browserInfo.indexOf("ipad") > 0;
    },
    is_app() {
      return this.browserInfo.indexOf("wikey_flutter") > 0;
    },
    is_mobile() {
      return this.is_ios || this.is_android;
    },
    is_development() {
      return process.env.NODE_ENV !== "production";
    },
    use_offline_mode() {
      return this.is_app && this.type == 'PRE';
    },
    is_using_popup_village() {
      // 사전방문 행사 조치 계획 노출 여부(사전점검 다음 날부터 노출)
      const hasOpen = Date.now() >= new Date(2026, 9, 19, 0, 0, 0).getTime();
      return ["AA00P0214D"].includes(this.home.erp_village_id) && hasOpen;
    },
    keyOutDateDict() {
      return this.$store.getters.getKeyOutDateDict;
    }
  },
  methods: {
    closePopup() {
      if (this.doNotShowToday) {	// checkbox === true면
        const now = new Date();		// 지금 시간을 변수 now에 적용
        now.setDate(30); // now의 오늘 자정시간 만들기
        localStorage.setItem("expireTodayTime", now.getTime());
        // 로컬스토리지에 'expireTodayTime'를 key값으로 삽입
        // value에 변수now 값(getTime)의 시간을 삽입
      }
      this.newisopenpop = false;	// checkbox === false 일땐 단순 닫기 
    },
    inRotate() {
      this.inrotate = true
      setTimeout(() => {
        this.inrotate = false
      }, 1000)
    },
    // APIs
    getItems() {
      let params = {
        sort: "createdAt,desc",
        customerUniqueNumber: this.user?.mobile.replaceAll("-", ""),
        // size: this.isSimple ? 10 : 10000,
        size: 10000,
      };

      if (this.type == "PRE") {
        params.type = "PRE";
        params.dongName = this.home.dong_no;
        params.hoName = this.home.ho_no;
        params.siteCode = this.home.erp_village_id;
      } else {
        params.typeIn = "SECOND_YEAR,THIRD_YEAR,TEN_YEAR,AFTER,MOVE_IN";
      }

      defect
        .getDefects(params)
        .then((res) => {
          if (res.data) {
            this.items = res.data.content.map((item, index) =>
              this.parse(item, index, res.data.totalElements)
            );
            if (res.data.totalElements > 10 && this.isSimple) {
              this.showLoadMore = true;
            }
          } else {
            this.items = [];
          }
        })
        .finally(() => {
          if (this.scrollY) {
            window.scrollTo(0, this.scrollY);
          }

          this.isLoading = false;
        });
    },
    parse(item, index, total) {
      item.order = `00${total - index}`.slice(-3);
      item.createdAtText = `등 록: ${this.timeForm(item.createdAt)}`;
      item.receiptAtText = `접 수: ${this.timeForm(item.receiptAt)}`;
      item.visitAtText = `방 문: ${this.timeForm(item.visitAt)}`;
      // item.completeAtText = `방 문: ${this.timeForm(item.completeAt)}`;

      item.customerName = this.maskingUserName(item.customer?.name) || "";

      if (item.customerName) {
        item.createdAtText += ` / ${item.customerName}`
        // item.receiptAtText += ` / ${item.customerName}`
        // item.visitAtText += ` / ${item.customerName}`
      }

      if (item.defectStatus === "WORK_DONE") {
        item.defectStatus = "OPEN";
      }

      // if (item.defectStatus === "REQUESTED") {
      //   item.defectStatus = "OPEN";
      // }

      item.title = `${item.siteDefectItem.areaName} > ${item.siteDefectItem.partName} > ${item.siteDefectItem.partDetailName}`;
      return item;
    },
    loadMore() {
      this.showLoadMore = false;
      this.isSimple = false;
      this.getItems();
    },
    // Utils
    timeForm(text) {
      if (!text) return "";
      return text.replace("T", " ").slice(0, 16);
    },
    colorByStatus(val) {
      if (val != this.status) return "grey darken-2";
      return (
        {
          ALL: "primary",
          CANCELLED: "red",
          REQUESTED: "success",
          OPEN: "primary",
          WORK_ORDERED: "success",
          CLOSE: "grey ",
        }[this.status] || "primary"
      );
    },
    moveToApp() {
      let type = "";

      if (this.$route.name == "DefectPreList") {
        type = "PRE";
      }

      return this.checkAppVersion().then((updateRequired) => {
        // console.log("앱 버전 체크 결과, 업데이트 필요 여부: ", updateRequired);
        if (updateRequired) {
          return Promise.reject(updateRequired);
        }

        let dong = this.home.dong_no;
        let ho = this.home.ho_no;
        let siteCode = this.home.erp_village_id;
        let siteName = this.home.village_name;
        let home_id = this.home.id;

        return new Promise((resolve, reject) => {
          try {
            window.flutter_inappwebview
              .callHandler("gotoCustomerDefectRegist", type, siteCode, siteName, dong, ho, home_id)
              .then(function (result) {
                console.log(
                  "@@@ flutterInAppWebViewPlatformReady gotoCustomerDefectRegist  result: ",
                  result
                ); // 호출하지 못한 경우 result=null이 내려옴
                if (result) {
                  resolve(result);
                } else {
                  reject(result);
                }
              })
              .catch((e) => {
                // client error 저장
                reject(e);
                this.$store.dispatch("LOGGING", {
                  error: e,
                  tags: `flutter_inappwebview|gotoCustomerDefectRegist()_failed`,
                  etc: {
                    type, siteCode, siteName, dong, ho, home_id
                  },
                });
              });
          } catch (err) {
            // logging
            this.$store.dispatch("LOGGING", {
              error: err,
              tags: `flutter_inappwebview|moveToApp()`,
              etc: {
                type, siteCode, siteName, dong, ho, home_id
              },
            });
            reject(err);
          }
        })
      });
    },
    checkAppVersion() {
      var updateRequired = false;
      let idToken = this.$store.getters.getIdToken;

      return window.flutter_inappwebview.callHandler("getAppInfo", idToken).then((result) => {
        var platform = '';
        var json = JSON.parse(result);
        var version = json.app_version;

        let browserInfo = navigator.userAgent.toLowerCase();

        if (browserInfo.indexOf("android") > 0) {
          platform = 'android';
        } else if (browserInfo.indexOf("iphone") > 0 || browserInfo.indexOf("ipad") > 0) {
          platform = 'ios';
        } 
        
        return checkAppVersion(platform, version).then((res) => {
          // 사전점검은 최신버전만 허용하도록 적용(2026.04.16)
          // const isForceUpdate = res.data.forceUpdate;
          const isNeedUpdate = res.data.needUpdate;
          updateRequired = isNeedUpdate;

          if (isNeedUpdate) {
            console.log('앱 업데이트 필요 사용자:', this.user?.email || "unknown");

            const message = res.data.message;
            const storeUrl = res.data.storeUrl;

            let check = confirm(message);

            if (check) {
              window.location.href = storeUrl;
            }
          }

          return updateRequired;
        }).catch((error) => {
          updateRequired = true;

          alert("오류가 발생했습니다. 관리자에게 문의해 주세요.");

          this.$store.dispatch("LOGGING", {
            error: error.message || error,
            tags: `flutter_inappwebview|defect_list_checkAppVersionAPI_failed(${this.user?.email || "unknown"})`,
            etc: {},
          });

          return updateRequired;
        });
      }).catch((error) => {
        updateRequired = true;

        alert("최신버전으로 업데이트 해주세요. 계속 오류가 발생하면 관리자에게 문의해 주세요.");
        this.$store.dispatch("LOGGING", {
          error: error.message || error,
          tags: `flutter_inappwebview|defect_list_checkAppVersion_failed(${this.user?.email || "알 수 없음"})`,
          etc: {},
        });

        return updateRequired;
      });
    },
    moveToAdd() {
      // 하자등록은 앱 사용시에만 가능, PC버전에서는 X (2024-11-08) -> 원복 (2024-11-15)
      // if(!this.is_app){
      //   this.$store.commit("ERROR", "AS접수는 모바일 앱에서만 가능합니다. 스마트린 앱을 설치해주세요.");
      //   return;
      // }

      //------- 전체 단지 대상으로, 사전점검만 오프라인 사용
      if (this.use_offline_mode) {
        this.isLoading = true;

        this.moveToApp().then((res) => {
          console.log("$$$$ moveToApp success");
        }).catch((e) => {
          console.log("$$$$ moveToApp failed", e);
          //추후 전체사용하게 되면 웹 페이지로 이동
          // this.moveToAddPage();

          // client error 저장
          // this.$store.dispatch("LOGGING", {
          //   error: e,
          //   tags: `flutter_inappwebview|gotoCustomerDefectRegist()`,
          //   etc: {},
          // });
        });
        
        this.isLoading = false;
      } else {
        this.moveToAddPage();
      }
      // ---------------------------------------------------


    },
    // @@@@ 사전점검 행사 중, 웹으로 전환해야할 시 moveToAdd를 아래로 바꿔주세요.
    // moveToAdd() {
    //
    //   this.moveAddPage();
    //
    // },
    moveToAddPage() {
      // 하자등록페이지로 이동(웹)
      if (this.$route.name == "DefectPreList") {
        this.$router.push({ name: "DefectPreAdd", query: { type: this.type } });
      } else {
        this.$router.push({ name: "DefectAdd", query: { type: this.type } });
      }
    },
    moveToDetail(id) {
      let surveyId = this.defectSurveysMap.get(id) || null;

      if (this.$route.name == "DefectPreList") {
        this.$router.push({
          name: "DefectPreDetail",
          params: { id: id },
          query: { type: this.type, scrollY: window.scrollY, surveyId: surveyId },
        });
      } else {
        this.$router.push({
          name: "DefectDetail",
          params: { id: id },
          query: { type: this.type, scrollY: window.scrollY, surveyId: surveyId },
        });
      }
    },
    // Survey
    checkSurvey() {
      const query = {
        location: "before_pre",
        skip_ids: this.$store.getters.getSurveySkipList,
      }
      checkSurvey(this.home.id, query).then(({ data }) => {
        this.survey = data
        this.survey.dialog = true
      })
    },

    // Utils
    maskingUserName(name) {
      // 유저 이름의 중간, (외자일 경우 성 제외) 문자를 *로 변경
      if (!name) return "";

      if (name.length == 1) return name;
      if (name.length == 2) return name[0] + "*";

      return name[0] + "*".repeat(name.length - 2) + name[name.length - 1];
    },
    getKeyOutDate() {
      if (this.keyOutDateDict && this.keyOutDateDict[this.home.id]) {
        return;
      }

      defect.getKeyOutDate({ siteCode: this.home.erp_village_id, dong: this.home.dong_no, ho: this.home.ho_no }).then(({ data }) => {
        this.$store.commit("SET_KEY_OUT_DATE_DICT", { id: this.home.id, data: data });
      })
    },
    getDefectSurveys() {
      let params = {
        customerUniqueNumber: this.user?.mobile.replaceAll("-", ""),
      };

      if (this.type == "PRE") {
        params.type = "PRE";
        params.dongName = this.home.dong_no;
        params.hoName = this.home.ho_no;
        params.siteCode = this.home.erp_village_id.slice(4,);
      } else {
        params.typeIn = "SECOND_YEAR,THIRD_YEAR,TEN_YEAR,AFTER,MOVE_IN";
        params.siteCode = this.home.erp_village_id.slice(4,);
      }

      defect.getDefectSurveys(params).then(({ data }) => {
        this.defectSurveys = data.filter(item => item.surveyId && item.surveyStatus == "AVAILABLE");
        console.log("this.defectSurveys", this.defectSurveys)
        this.defectSurveys.forEach(item => {
          this.defectSurveysMap.set(item.defectId, item.surveyId);
        });
      })
    }
  },
  created() {

    this.type = this.$route.query.type || "AFTER";
    if (this.$route.query.scrollY) {
      this.scrollY = Number(this.$route.query.scrollY || 0);
    } else {
      try {
        this.scrollY = this.$previousRoute.split("scrollY=")[1];
      } catch {
        this.scrollY = 0;
      }
    }
    // this.scrollY 초기화
    this.$router.replace({ query: { type: this.type } });

    if (this.type == "AFTER") {
      if (!this.home || !this.home.is_defect_after_open) {
        this.$router.push({ name: "dwelling" });
      }
    } else {
      if (!this.home || !this.home.is_defect_pre_open) {
        this.$router.push({ name: "contract" });
      }
    }

    if (this.type == "PRE") {
      this.checkSurvey();
    }

    this.getItems();
    // 키불출일 업데이트
    this.getKeyOutDate();
    // 하자등록 설문 조회
    this.getDefectSurveys();

  },
};
</script>

<style scoped>
.item-card {
  border-radius: 10px;
  margin-bottom: 10px;
  text-align: left;
}

.float-add-button {
  margin-bottom: 50px;
}

.v-list-item__content {
  align-items: center;
  align-self: center;
  display: flex;
  flex-wrap: wrap;
  flex: 1 1;
  overflow: hidden;
  padding: 4px 0;
}

.order-style {
  position: absolute;
  bottom: 5px;
  right: 10px;
  color: grey;
}

.testPopSet {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #FFFFFF;
  padding: 25px 15px;
}

.testPopSet .testPSTitle {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: 700;
  color: #333333;
  padding: 5px 0;
  margin-bottom: 20px;
  font-size: 20px;
}

.testPopSet .testPSText {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.testPopSet p {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  font-weight: 400;
  color: #333333;
  padding: 5px 0;
  margin: 0;
  font-size: 14px;
  line-height: 1.2;
  letter-spacing: -0.50px;
  word-break: keep-all;
}

.testPopSet p.big {
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 10px;
}

.testPopSet p.color {
  color: #e66a1f;
  font-weight: 500;
}

.testPopSet p.inc {
  padding-left: 12px;
  position: relative;
}

.testPopSet p.inc:after {
  content: "";
  display: block;
  width: 4px;
  height: 4px;
  background-color: #333333;
  position: absolute;
  top: 11px;
  left: 1px;
  border-radius: 4px;
}

.testSetBtn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px 15px;
  align-items: center;
  background-color: #aaaaaa;
}

.testSetBtn .v-btn {
  width: 80px;
  font-size: 14px;
  font-weight: 400;
  justify-content: center;
  align-items: center;
}

.testSetBtn label {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  color: #FFFFFF;
  font-size: 14px;
}

.testSetBtn input[type=checkbox] {
  width: 16px;
  height: 16px;
  margin-right: 5px;
  border: 1px solid #e3e3e3;
  background-color: #FFFFFF;
  border-radius: 3px;
}

.testSetBtn input[type=checkbox]:checked {
  appearance: checkbox;
}
</style>
